import { combineReducers } from 'redux';
import globalSystemInfo from './globalSystemInfo';
import settings from './settings';
import { StateAppType } from './types';

const reducer = combineReducers<StateAppType>({ settings, globalSystemInfo });

export default reducer;
